import { render, staticRenderFns } from "./HeaderPage.vue?vue&type=template&id=4095d52e&scoped=true&"
import script from "./HeaderPage.vue?vue&type=script&lang=js&"
export * from "./HeaderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4095d52e",
  null
  
)

export default component.exports